export default function permissionsReducer (state = null, action) {
  switch (action.type) {
    case 'SET_PERMISSIONS_EXTRA':
      return action.payload;
    default:
      return state;
  }
};